import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import swal from 'sweetalert';
import api from 'services/api';
// import moment from 'moment';

import { Creators as BenefitsTypesActions, Types as BenefitsTypesTypes } from 'store/ducks/benefitsTypes';
import vouchers from 'services/vouchers';

function* getBenefitTypeRequest(action) {
  try {
    const { id } = action.payload;
    const url = `/experience/voucher_configurations/${id}`;
    const response = yield call(vouchers.get, url);
    yield put(BenefitsTypesActions.getBenefitTypeSuccess(response.data));
  } catch (error) {
    yield put(BenefitsTypesActions.getBenefitTypeFailure());
  }
}

function* getBenefitsTypesRequest(action) {
  try {
    const { page } = action.payload;

    const url = `/experience/voucher_configurations?page=${page}&per=25`;
    const response = yield call(vouchers.get, url);

    yield put(BenefitsTypesActions.getBenefitsTypesSuccess(response.data));
  } catch (error) {
    yield put(BenefitsTypesActions.getBenefitsTypesFailure());
  }
}

function* createBenefitsTypesRequest(action) {
  try {
    const { data } = action.payload;
    const url = '/experience/voucher_configurations';

    yield call(vouchers.post, url, data);

    yield put(push('/benefits/types/list'));
    yield call(swal, 'Adicionado', 'Tipo de benefício adicionada com sucesso!', 'success');
    yield put(BenefitsTypesActions.createBenefitsTypesSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao atualizar', 'Não foi possível criar o tipo de benefício.', 'error');
    yield put(BenefitsTypesActions.createBenefitsTypesFailure());
  }
}

function* updateBenefitsTypesRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `/experience/voucher_configurations/${id}`;
    yield call(vouchers.put, url, data);
    yield put(push('/benefits/types/list'));
    yield call(swal, 'Atualizado', 'Tipo de benefício atualizado com sucesso!', 'success');
    yield put(BenefitsTypesActions.updateBenefitsTypesSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao atualizar', 'Não foi possível atualizar o tipo de benefício.', 'error');
    yield put(BenefitsTypesActions.updateBenefitsTypesFailure());
  }
}

function* getBenefitsTypesPlansRequest(action) {
  try {
    const url = "experience/v2/plans?page=1&per=100&gives_points_value=true";
    const response = yield call(api.get, url);

    yield put(BenefitsTypesActions.getBenefitsTypesPlansSuccess(response.data));
  } catch (error) {
    yield put(BenefitsTypesActions.getBenefitsTypesPlansFailure());
  }
}

export default function* saga() {
  yield takeLatest(BenefitsTypesTypes.GET_REQUEST, getBenefitTypeRequest);
  yield takeLatest(BenefitsTypesTypes.GET_LIST_REQUEST, getBenefitsTypesRequest);
  yield takeLatest(BenefitsTypesTypes.CREATE_REQUEST, createBenefitsTypesRequest);
  yield takeLatest(BenefitsTypesTypes.UPDATE_REQUEST, updateBenefitsTypesRequest);
  yield takeLatest(BenefitsTypesTypes.GET_PLANS_REQUEST, getBenefitsTypesPlansRequest);
}
